import { useState, useEffect } from "react";

export default function PaxInput({ value, onChange, min = 1, max = 50, className = "", testid = "pax" }) {
  const [text, setText] = useState(String(value ?? min));
  useEffect(() => { setText(String(value ?? min)); }, [value]);

  const clamp = (n) => Math.max(min, Math.min(max, n));
  const commit = () => {
    const n = parseInt(text, 10);
    const next = Number.isNaN(n) ? clamp(value || min) : clamp(n);
    setText(String(next));
    onChange(next);
  };
  const step = (d) => {
    const n = clamp((parseInt(text, 10) || value || min) + d);
    setText(String(n));
    onChange(n);
  };

  const btn = "h-11 w-11 shrink-0 border border-zinc-300 bg-white text-zinc-600 text-lg font-bold active:scale-95 transition flex items-center justify-center disabled:opacity-40";
  const cur = parseInt(text, 10);
  return (
    <div className="flex items-stretch">
      <button type="button" onClick={() => step(-1)} disabled={(Number.isNaN(cur) ? (value || min) : cur) <= min}
        data-testid={`${testid}-minus`} aria-label="Riduci" className={`${btn} rounded-l-md border-r-0`}>−</button>
      <input type="number" inputMode="numeric" min={min} max={max} value={text}
        onChange={(e) => setText(e.target.value)}
        onBlur={commit}
        data-testid={testid}
        className={`w-full h-11 px-3 border border-zinc-300 text-sm bg-white text-center focus:outline-none focus:ring-2 focus:ring-zinc-400 [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none ${className}`} />
      <button type="button" onClick={() => step(1)} disabled={(Number.isNaN(cur) ? (value || min) : cur) >= max}
        data-testid={`${testid}-plus`} aria-label="Aumenta" className={`${btn} rounded-r-md border-l-0`}>+</button>
    </div>
  );
}
